import { FC } from "react"
import { useNavigate } from "react-router-dom";
import styles from './index.module.css';

const DiscountBanner: FC<{ withButton?: boolean }> = ({ withButton }) => {
  const navigate = useNavigate();
  return <div className={styles['discount-banner']}>
    <img
      src="/images/discount-text.svg"
      alt="Discount"
    />
    Order today and get an extra 3-month trial.
    {
      withButton &&
      <button
        className={styles['detail-btn']}
        onClick={() => {
          navigate("/plans");
        }}
      >
        Get this deal
      </button>
    }
  </div>
}

export default DiscountBanner;